import { Row } from "@tanstack/react-table";
import {
  MINIMIZED_SIDEBAR_WIDTH,
  PAGE_PADDING,
  SIDEBAR_WIDTH
} from "./constants";

type WithFirst<T> = T & { isFirstOfAType?: true };

export function getNestedValue<T extends object>(
  obj: T,
  path: string
): unknown {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- key can not always be present
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
}

// injects array with isFirstOfAType: true
export function markFirstOfType<T extends object>(
  arr: Row<T>[],
  groupBy?: string
): WithFirst<Row<T>>[] {
  if (!groupBy) return arr;

  const seen = new Set<unknown>();

  return arr.map((item) => {
    const value = getNestedValue(item.original, groupBy);
    if (!seen.has(value)) {
      seen.add(value);
      return { ...item, isFirstOfAType: true };
    }
    return item;
  });
}

export const calculateMaw = ({
  maw,
  mawWidthRatio,
  isMinimizedSidebar,
  width
}: {
  maw?: number;
  mawWidthRatio?: number;
  isMinimizedSidebar?: boolean;
  width: number | null;
}) => {
  const sidebarWidth =
    isMinimizedSidebar || (width || 0) < 1024
      ? MINIMIZED_SIDEBAR_WIDTH
      : SIDEBAR_WIDTH;

  return (
    maw || (width || 0) * (mawWidthRatio || 1) - sidebarWidth - PAGE_PADDING
  );
};
